import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API endpoints
export const authAPI = {
  login: (credentials) => api.post('/users/login', credentials),
  register: (userData) => api.post('/users/register', userData),
  getProfile: (userId) => api.get(`/users/${userId}`),
};

export const postsAPI = {
  getAll: (params = {}) => api.get('/posts', { params }),
  getById: (id) => api.get(`/posts/${id}`),
  create: (postData) => api.post('/posts', postData),
  update: (id, postData) => api.put(`/posts/${id}`, postData),
  delete: (id) => api.delete(`/posts/${id}`),
  addReview: (id, reviewData) => api.post(`/posts/${id}/reviews`, reviewData),
};

export const housingAPI = {
  getAll: (params = {}) => api.get('/housing', { params }),
  getById: (id) => api.get(`/housing/${id}`),
  create: (housingData) => api.post('/housing', housingData),
  update: (id, housingData) => api.put(`/housing/${id}`, housingData),
  delete: (id) => api.delete(`/housing/${id}`),
};

export const jobsAPI = {
  getAll: (params = {}) => api.get('/jobs', { params }),
  getById: (id) => api.get(`/jobs/${id}`),
  create: (jobData) => api.post('/jobs', jobData),
  apply: (jobId, applicationData) => api.post(`/jobs/${jobId}/apply`, applicationData),
};

export default api;